import React from 'react';
import { ExternalLink } from 'lucide-react';

const INTRO_VIDEO_URL = 'https://youtu.be/LUs2xmCA7l0?si=0_f3vj-gPKug3f9h';

const getYouTubeEmbedUrl = (url) => {
  const videoId = url.split('youtu.be/')[1]?.split('?')[0] || url.split('v=')[1]?.split('&')[0];
  return `https://www.youtube.com/embed/${videoId}?autoplay=0&rel=0`;
};

const IntroVideoSection = () => {
  return (
    <section
      id="introduction"
      className="bg-[#1a1a1a] py-12 lg:py-20 px-4 sm:px-8 lg:px-12"
      data-testid="intro-video-section"
    >
      <div className="max-w-7xl mx-auto w-full">
        {/* Section Header */}
        <div className="text-center mb-8 lg:mb-14">
          <h2 className="font-display text-5xl sm:text-6xl md:text-7xl font-black text-white mb-3 lg:mb-4">
            THE <span className="text-[#4ECDC4]">INTRODUCTION</span>
          </h2>
          <div className="w-20 lg:w-24 h-1 bg-[#4ECDC4] mx-auto mb-4 lg:mb-6"></div>
          <p className="text-gray-400 text-sm lg:text-lg max-w-2xl mx-auto px-2 leading-relaxed">
            A quick hello — get to know me, my journey, and what drives me as a performer.
          </p>
        </div>

        {/* Video Container */}
        <div className="max-w-5xl mx-auto">
          <div className="relative group">
            {/* Glow Effect */}
            <div className="absolute -inset-1 bg-gradient-to-r from-[#4ECDC4] via-[#4ECDC4]/60 to-[#FFD700] rounded-lg blur-xl opacity-30 group-hover:opacity-50 transition-opacity duration-500"></div>

            {/* Video Frame */}
            <div className="relative bg-black rounded-lg overflow-hidden shadow-2xl aspect-video">
              <iframe
                src={getYouTubeEmbedUrl(INTRO_VIDEO_URL)}
                title="Introduction — Komal Verma"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
                data-testid="intro-video-iframe"
              ></iframe>
            </div>
          </div>

          {/* CTA Below Video */}
          <div className="mt-5 lg:mt-10 text-center">
            <a
              href={INTRO_VIDEO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#4ECDC4] hover:text-[#FFD700] transition-colors group"
              data-testid="intro-video-youtube-link"
            >
              <span className="text-sm lg:text-lg font-medium">Watch on YouTube</span>
              <ExternalLink size={16} className="lg:w-5 lg:h-5 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroVideoSection;
